import { render } from "./ActivateUser.vue?vue&type=template&id=1424aac4"
import script from "./ActivateUser.vue?vue&type=script&lang=js"
export * from "./ActivateUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__